module.exports = __webpack_public_path__ + "img/Leap Util Usage guide.dc6d18a0.png";